// src/poc/helpers/tableUtils.js

import { formatMoney, formatPercentSmart } from '../../../helpers/utils'
import { CATEGORY_LABELS } from '../constants/metricConstants'
import { resolveFillRateDifference } from './fillRateMetrics'

export const isBlank = (value) =>
  value === null || value === undefined || value === ''


export const tableValue = (value, fallback = '-') =>
  isBlank(value) ? fallback : value

export const safeValue = (value) =>
  tableValue(value)

export const valueOrDash = (value) =>
  tableValue(value)

export const headerValue = (value) =>
  tableValue(value, 'N/A')


export const safeMoney = (value) =>
  isBlank(value) ? '-' : formatMoney(value)

export const moneyCell = (value) =>
  safeMoney(value)


export const formatPercent = (value, decimals = null) => {
  if (isBlank(value) || isNaN(value)) return '-'

  const numeric =
    decimals !== null ? Number(value).toFixed(decimals) : value

  return `${numeric}%`
}

export const percentCell = (value) =>
  formatPercent(value, 2)


export const safeDivPercent = (num, den) => {
  if (den === 0 && num === 0) return 0
  if (den > 0) return (num / den) * 100
  return null
}

export const formatTableValue = (value, type) => {
  if (isBlank(value)) return '-'

  switch (type) {
    case 'money':
      return formatMoney(value)
    case 'percent':
      return formatPercentSmart(value)
    default:
      return value
  }
}

export const differenceMoneyCell = (purchaseOrderTotal, orderTotal) => {
  const difference = resolveFillRateDifference({
    purchase_order_total: purchaseOrderTotal,
    order_total: orderTotal
  })

  if (difference === 0) return '-'
  if (difference > 0) return formatMoney(difference)

  return `-${formatMoney(Math.abs(difference))}`
}

export const resolveCategoryLabel = (value) => {
  if (!value) return '-'

  return CATEGORY_LABELS[value] || value
}


export const resolveItemTotal = (item) => {
  if (!item) return null

  const quantity = Number(item.quantity)
  const price = Number(item.price)

  if (Number.isNaN(quantity) || Number.isNaN(price)) return null

  return quantity * price
}


export const resolveChildValue = (child, col) => {
  switch (col.key) {
    case 'buyer':
      return resolveCategoryLabel(child.name)

    case 'purchase_order_total':
      return formatMoney(child.total_oc)

    case 'order_total':
      return formatMoney(child.total_pedido)

    case 'difference':
      return differenceMoneyCell(child.total_oc, child.total_pedido)

    default:
      return '-'
  }
}
